import React from 'react';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';

export default function PreviousPageLink({location, text}) {
    return (
        <p className="previous-page-link-row">
            <span className="la-TriangleLeft"></span>
            <Link className="action-link" to={location}>
                <FormattedMessage id={text} />
            </Link>
        </p>
    );
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/PreviousPageLink/PreviousPageLink.jsx